import { SetupEntryDispatcher } from '@/features/setup/routes/setup-entry-dispatcher';
export default SetupEntryDispatcher;
